<template>
  <!-- {{ $t("paygame.paygame") }} -->
  <!-- {{ $t("paygame.komoeAccount") }} -->
  <div class="setoutpay">
    <div class="setoutpay-content">
      <div class="setoutpay-content-left">
        <ul>
          <li class="head">{{ $t("paygame.paygame") }}</li>
          <li class="head">{{ $t("paygame.komoeAccount") }}</li>
          <li class="inpuname">{{ $t("paygame.gameServer") }}</li>
          <li class="inpuname">{{ $t("paygame.gameRole") }}</li>

          <li class="inpuname">{{ $t("paygame.payCurrency") }}</li>
          <li class="inpuname">{{ $t("paygame.payWay") }}</li>
          <li class="inpuname">{{ $t("paygame.payCount") }}</li>
          <li class="inpuname">{{ $t("paygame.payAmount") }}</li>
          <li v-if="!isProductSelect" class="inpuname">
            {{ $t("paygame.captcha") }}
          </li>
        </ul>
      </div>
      <div class="setoutpay-content-right">
        <ul>
          <li class="heads">
            {{ dataForm.game_name }}
          </li>
          <li class="heads">
            {{ dataForm.user_name }}
          </li>
          <li class="inpunames">
            <!-- // placeholder:提示
  // model:数据类型（array，json）
  // selname:显示的内容名称
  //dataList：数据 -->
            <select-input
              ref="info0"
              :placeholder="$t('paygame.gameServer')"
              :model="'json'"
              :dataList="serveInfo"
              :selname="'cp_server_name'"
              @changValue="changValue"
              :stateTitle="$t('paygame.msg1')"
            ></select-input>
          </li>
          <li class="inpunames">
            <select-input
              ref="info1"
              :placeholder="$t('paygame.gameRole')"
              :model="'json'"
              :dataList="roleInfo"
              :selname="'cpRoleName'"
              @changValue="changValue1"
              :stateTitle="$t('paygame.msg2')"
            ></select-input>
          </li>

          <li class="inpunames">
            <select-input
              ref="info"
              :placeholder="$t('paygame.payCurrency')"
              :model="'json'"
              :dataList="currencyList"
              :selname="'currency'"
              @changValue="changValue3"
              :stateTitle="$t('paygame.payCurrency')"
            ></select-input>
          </li>
          <li class="inpunames">
            <select-input
              ref="info2"
              :placeholder="$t('paygame.payWay')"
              :model="'json'"
              :dataList="payChannel"
              :selname="'payment_desc'"
              @changValue="changValue4"
              :stateTitle="$t('paygame.msg4')"
            ></select-input>
          </li>
          <li class="inpunames">
            <select-input
              ref="info3"
              :placeholder="$t('paygame.payCount')"
              :model="'json'"
              :dataList="productList"
              :selname="'product_name'"
              @changValue="changValue5"
              :stateTitle="$t('paygame.msg3')"
            ></select-input>
          </li>
          <li class="inpunames pay">
            <span>{{ merchandiseInfo.moneyAmount }}</span
            ><span>{{ merchandiseInfo.moneyName }}</span>
          </li>
          <!--  v-if="!isProductSelect" -->
          <li class="inpunames codes" v-if="!isProductSelect">
            <input-data
              ref="codes"
              v-model.trim="merchandiseInfo.captcha_code"
              :placeholder="$t('paygame.insertCaptcha')"
              :stateTitle="$t('paygame.msg5')"
            >
              <div
                class="yanzm"
                :style="
                  ` background: url(${merchandiseInfo.imgUrl}) no-repeat center /cover;`
                "
                @click="getCode"
              ></div>
            </input-data>
          </li>
        </ul>
      </div>
      <div class="tox">
        <img :src="dataForm.game_img" alt="" />
      </div>
    </div>
    <div
      class="setoutpay-btn"
      v-if="main_switch_status == 1 && secondary_switch_status == 1"
      @click="makeSure"
    >
      <span>{{ $t("paygame.payNow") }}</span>
    </div>
    <div class="setoutpay-state">
      <img
        v-if="chenckShow"
        @click="chenckShow = false"
        src="@/assets/images/h5/icon18.png"
        alt=""
      />
      <img
        v-if="!chenckShow"
        @click="chenckShow = true"
        src="@/assets/images/h5/icon19.png"
        alt=""
      /><span>
        {{ $t("paygame.agree1")
        }}<a href="/terms/">《{{ $t("paygame.agree2") }}》</a></span
      >
    </div>
    <h5-nav v-if="$region !== 'jp' "></h5-nav>
  </div>
</template>
<script>
import utils from "@/utils";
const { getParams } = utils;
import selectInput from "./component/selectInput.vue";
import inputData from "./component/inputdata.vue";
import { mapGetters } from "vuex";
import h5Nav from "@/component/h5nav/komoe";
export default {
  name: "pay_h5Setoutpay",
  components: {
    selectInput,
    h5Nav,
    inputData,
  },
  data() {
    return {
      ulwidth: 0,
      lineIndex: 1,
      chenckShow: true,
      distribution_region: 5,
      main_switch_status: "",
      secondary_switch_status: "",
      currencyList: [],
      serverRoleList: [],
      serveInfo: [],
      roleInfo: [],
      payChannel: [],
      productList: [],
      isProductSelect: true,
      payment_url: "",
      order_no: "",
      merchandiseInfo: {
        game_id: "",
        game_base_id: "",
        cp_server_id: "",
        serverStatus: "",
        cp_role_id: "",
        cp_role_pay_status: "",
        cp_role_name: "",
        product_id: "",
        product_name: "",
        captcha_code: "",
        currency: "", //币种
        payment_desc: "", //充值方式
        pay_mode: "", //充值方式id
        product_price: "", //商品价格
        moneyName: "", //商品价格单位
        moneyAmount: "", //商品价格数值
        payment_type: "", //充值方式type,
        marketing_desc_1: "",
        marketing_desc_2: "",
        imgUrl: "",
        game_name: "",
        account: "",
        main_switch_status: "",
        secondary_switch_status: "",
      },
      params: {
        game_base_id: "", // 游戏基础ID
        game_id: "", // 游戏ID
        game_name: "", // 游戏名称
        account: "", // 账号
        id_server: "",
        cp_server_id: "", // 用户所在的游戏服务器区服id
        serverStatus: "", // 小区服状态
        id_role: "",
        cp_role_id: "", // 用户游戏内角色id
        cp_role_name: "", // 角色名字
        cp_role_pay_status: "", // 角色是否可以充值
        product_id: "", // product的ID
        product_name: "", // product名称
        product_icon: "", // 商品图片icon
        payment_desc: "", // 支付方式名称
        marketing_desc_1: "",
        marketing_desc_2: "",
        product_price: "", // 实付金额
        currency: "", // currency
        pay_mode: "", // 支付方式
        payment_type: null, // 具体支付方式
        imgUrl: "",
        captcha_token: "", // 验证码token
        captcha_code: "", //captcha_code
      },
      dataForm: {
        game_id: "",
        game_name: "",
        user_name: "",
        game_img: "",
      },

      accountType:
        getParams("type") === "both"
          ? "both"
          : this.$region === "jp" || this.$area === "komoe-sea"
          ? "email"
          : "phone",
      codeImg: "",
      lists: [
        { name: "yc", id: 1 },
        { name: "yc1", id: 2 },
        { name: "yc2", id: 3 },
      ],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.dataForm.game_id = this.$route.query.gameId;
    this.dataForm.game_name = this.$route.query.gameName;
    this.dataForm.game_img = this.$route.query.gameImg;
    if (!this.dataForm.game_id) {
      this.$router.push({
        path: "/h5",
      });
      return;
    }
    this.getSwitchStatus();
  },
  mounted() {
    // this.getRoleList();
  },
  methods: {
    // 点击确认按钮，弹出充值信息确认弹窗
    makeSure() {
      if (!this.merchandiseInfo.game_id && !this.merchandiseInfo.cp_server_id) {
        // this.errMsg2Key("msg1");
        this.$refs.info0.setinputstate();
        return;
      } else if (this.merchandiseInfo.serverStatus == 1) {
        this.errMsg2Key("msg7");
        return;
      } else if (!this.merchandiseInfo.cp_role_id) {
        // this.errMsg2Key("msg2");
        this.$refs.info1.setinputstate();
        return;
      } else if (this.merchandiseInfo.cp_role_pay_status == 1) {
        this.errMsg2Key("msg8");
        return;
      } else if (!this.merchandiseInfo.currency) {
        this.$refs.info.setinputstate();
        return;
      } else if (this.isProductSelect && !this.merchandiseInfo.pay_mode) {
        // this.errMsg2Key("msg4");
        this.$refs.info2.setinputstate();
        return;
      } else if (this.isProductSelect && !this.merchandiseInfo.product_id) {
        // this.errMsg2Key("msg3");
        this.$refs.info3.setinputstate();
        return;
      } else if (!this.merchandiseInfo.captcha_code && !this.isProductSelect) {
        this.$refs.codes.setinputstate();
        // this.errMsg2Key("msg5");
        return;
      } else if (!this.chenckShow) {
        this.errMsg2Key("msg6");
        return;
      }

      if (this.isProductSelect) {
        this.merchandiseInfo.game_id = this.serverRoleList[0].game_id;
        this.merchandiseInfo.game_base_id = this.dataForm.game_id;
        this.merchandiseInfo.game_name = this.dataForm.game_name;
        this.merchandiseInfo.account = this.dataForm.user_name;
        this.merchandiseInfo.secondary_switch_status = this.secondary_switch_status;
        this.merchandiseInfo.main_switch_status = this.main_switch_status;
        let json = this.merchandiseInfo;
        this.$router.push({
          path: "/pay_h5/payaffirm",
          query: {
            dataInfo: JSON.stringify(json),
          },
        });
      } else {
        this.createOrder();
      }
    },
    errMsg2Key(val) {
      this.$notify({
        // type: "danger",
        message: this.$t(`paygame.${val}`),
        color: "#fff",
        background: "#50bbe5",
      });
    },
    // 游戏充值下单 确认弹窗按钮点击
    createOrder() {
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      this.$apis.paygame
        .addPayOrder(
          this.distribution_region,
          this.dataForm.game_id,
          this.serverRoleList[0].game_id,
          this.merchandiseInfo.cp_server_id,
          this.merchandiseInfo.cp_role_id,
          this.merchandiseInfo.product_id,
          this.params.product_name,
          this.merchandiseInfo.marketing_desc_1,
          this.merchandiseInfo.marketing_desc_2,
          // this.merchandiseInfo.product_price,
          this.merchandiseInfo.moneyAmount,
          this.merchandiseInfo.currency,
          this.merchandiseInfo.pay_mode,
          this.merchandiseInfo.payment_type,
          this.merchandiseInfo.captcha_token,
          this.merchandiseInfo.captcha_code
        )
        .then(({ data }) => {
          this.$toast.clear();
          if (data.code == 0) {
            this.payment_url = data.data.redirect_url;
            this.order_no = data.data.order_no;
            // 打开去支付
            if (this.payment_url) {
              window.open(this.payment_url);
            }
          } else {
            if (data.code === -101) {
              this.$router.push({
                name: "/login_h5",
              });
            } else if (data.code == -105) {
              if (this.isProductSelect) {
                this.errMsg2Key("err1");
              } else {
                this.errMsg2Key("msg9");
              }
            } else if (data.code == 1001) {
              this.errMsg2Key("err2");
            } else if (data.code == 2000) {
              this.errMsg2Key("err3");
            } else if (data.code == 2001) {
              this.errMsg2Key("err4");
            } else if (data.code == 2002) {
              this.errMsg2Key("err5");
            } else if (data.code == 2003) {
              this.errMsg2Key("err6");
            } else if (data.code == 2004) {
              this.errMsg2Key("err7");
            } else if (data.code == 2005) {
              this.errMsg2Key("err8");
            } else if (data.code == 2006) {
              this.errMsg2Key("err9");
            } else if (data.code == 2007) {
              this.errMsg2Key("err10");
            } else if (data.code == 2008) {
              this.errMsg2Key("err11");
            } else if (data.code == 2009) {
              this.errMsg2Key("err12");
            } else if (data.code == 2011) {
              this.errMsg2Key("err13");
            } else if (data.code == 2012) {
              this.errMsg2Key("msg10");
            } else {
              // 服务器内部错误
              this.errMsg2Key("err2");
            }
            // if (tag === "common") {
            //   this.errMsgInfo = this.errMsgSure;
            //   this.showCommonModal = true;
            // }
            this.getCode();
          }
        })
        .catch(() => {
          this.$toast.clear();
          this.errMsg2Key("err2");
        });
    },
    // 1.获取平台充值开关状态
    async getSwitchStatus() {
      this.$apis.paygame
        .getSwitchStatus(this.distribution_region)
        .then(({ data }) => {
          if (data.code == 0) {
            this.main_switch_status = data.data.main_switch_status;
            this.secondary_switch_status = data.data.secondary_switch_status;

            // 支付总开关和游戏充值二级菜单开关状态是否开启
            if (
              this.main_switch_status === 1 &&
              this.secondary_switch_status === 1
            ) {
              // 2.获取支持网页支付游戏信息接口
              // this.getOrderList();
              // 判断是否登录
              // if (!this.userInfo.mid) {
              //   this.$router.push({
              //     name: "login_h5",
              //   });
              //   return;
              // }
             
              this.getRoleList();
              this.getCode();
            } else {
              this.$router.push({ path: "/h5" });
            }
             this.dataForm.user_name = this.userInfo.nick_name || "N/A";
          } else {
            this.$router.push({ path: "/h5" });
          }
        });
    },
    changValue(e) {
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      this.merchandiseInfo.cp_server_id = e.cp_server_id;
      this.merchandiseInfo.serverStatus = e.cp_server_status;
      this.roleInfo = e.cp_roles;
      this.merchandiseInfo.cp_role_id = "";
      this.merchandiseInfo.cp_role_name = "";
      this.$refs.info1.resetValue();
      setTimeout(() => {
        _that.$toast.clear();
      }, 500);
    },
    changValue1(e) {
      this.merchandiseInfo.cp_role_id = e.cpRoleId;
      this.merchandiseInfo.cp_role_pay_status = e.cpRolePayStatus;
      this.merchandiseInfo.cp_role_name = e.cpRoleName;
    },
    // 充值币种
    changValue3(e) {
      // console.log(e);
      this.merchandiseInfo.currency = e.currency;
      this.getChannelList(this.merchandiseInfo.currency);
      this.merchandiseInfo.payment_desc = "";
      this.merchandiseInfo.pay_mode = "";
      this.merchandiseInfo.payment_type = "";
      this.productList = [];
      this.$refs.info2.resetValue();
      this.$refs.info3.resetValue();
      this.merchandiseInfo.moneyAmount = "";
      this.merchandiseInfo.moneyName = "";
      this.merchandiseInfo.marketing_desc_1 = "";
      this.merchandiseInfo.marketing_desc_2 = "";
      this.merchandiseInfo.product_name = "";
      this.merchandiseInfo.product_id = "";
    },
    // /付款方式
    changValue4(e) {
      // console.log(e);
      this.merchandiseInfo.payment_desc = e.payment_desc;
      this.merchandiseInfo.pay_mode = e.pay_mode;
      this.merchandiseInfo.payment_type = e.payment_type;
      this.getProductList(
        this.serverRoleList[0].game_id,
        this.merchandiseInfo.currency,
        this.merchandiseInfo.pay_mode
      );
      this.$refs.info3.resetValue();
      this.merchandiseInfo.moneyAmount = "";
      this.merchandiseInfo.moneyName = "";
      this.merchandiseInfo.marketing_desc_1 = "";
      this.merchandiseInfo.marketing_desc_2 = "";
      this.merchandiseInfo.product_name = "";
      this.merchandiseInfo.product_id = "";
      if (
        (this.merchandiseInfo.pay_mode === 107 &&
          this.merchandiseInfo.payment_type === "pin") ||
        (this.merchandiseInfo.pay_mode === 108 &&
          this.merchandiseInfo.payment_type === "card") ||
        (this.merchandiseInfo.pay_mode === 108 &&
          this.merchandiseInfo.payment_type === "vietnamVMS") ||
        (this.merchandiseInfo.pay_mode === 108 &&
          this.merchandiseInfo.payment_type === "vietnamVTT") ||
        (this.merchandiseInfo.pay_mode === 108 &&
          this.merchandiseInfo.payment_type === "vietnamFPT") ||
        (this.merchandiseInfo.pay_mode === 108 &&
          this.merchandiseInfo.payment_type === "vietnamZING") ||
        (this.merchandiseInfo.pay_mode === 108 &&
          this.merchandiseInfo.payment_type === "vietnamVNP")
      ) {
        this.isProductSelect = false;
      } else {
        this.isProductSelect = true;
      }
      this.$refs.info3.setbag(this.isProductSelect);
    },
    // 充值数量
    changValue5(e) {
      // console.log(e);
      this.merchandiseInfo.marketing_desc_1 = e.marketing_desc1 || "";
      this.merchandiseInfo.marketing_desc_2 = e.marketing_desc2 || "";
      this.merchandiseInfo.product_name = e.product_name;
      this.merchandiseInfo.moneyAmount = e.product_price;
      this.merchandiseInfo.product_id = e.product_id;
      this.merchandiseInfo.moneyName = `(${e.currency})`;
    },
    switchCaptchaLine() {
      this.getCode();
    },
    // 獲取圖形驗證碼
    getCode() {
      this.merchandiseInfo.imgUrl = "";
      this.$apis.paygame
        .getCaptcha(this.distribution_region)
        .then(({ data }) => {
          if (data.code == 0) {
            this.merchandiseInfo.imgUrl = data.data.img_url;
            this.merchandiseInfo.captcha_token = data.data.img_token;
          }
        });
    },

    // 根据gameBaseId查询接口3 区服、角色信息 serverRoleList
    getRoleList() {
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      this.$apis.paygame
        .getRoleList(this.distribution_region, this.dataForm.game_id)
        .then(({ data }) => {
          this.$toast.clear();
          if (data.code == 0) {
            // 获取区服、角色数据
            this.serverRoleList = data.data;
            // 对接口3数据做判断，如果用户没有任何角色信息，则不打开充值页面
            if (this.serverRoleList.length > 0) {
              // 是否有角色
              if (this.serverRoleList[0].cp_servers.length <= 0) {
                this.$notify({
                  color: "#fff",
                  background: "#50bbe5",
                  message: _that.$t("paygame.msg9"),
                });
                this.$router.push({
                  path: "/pay_h5",
                });
                return;
              }
              this.serveInfo = this.serverRoleList[0].cp_servers;
              this.getCurrencyList();
            } else {
              this.$notify({
                color: "#fff",
                background: "#50bbe5",
                message: _that.$t("paygame.err2"),
              });
            }
          } else if (data.code == -101) {
            // this.$router.push({
            //   name: "login_h5",
            // });
          } else if (data.code == 2012) {
            // this.errMsgInfo = this.$t("paygame.msg10");
            this.$notify({
              color: "#fff",
              background: "#50bbe5",
              message: _that.$t("paygame.msg10"),
            });
          } else {
            this.$notify({
              color: "#fff",
              background: "#50bbe5",
              message: _that.$t("paygame.err2"),
            });
            // this.errMsgInfo = this.$t("paygame.err2");
          }
          // this.bigLoading = false;
        })
        .catch(() => {
          this.$toast.clear();
          // this.errMsgSure = this.$t("paygame.err2");
          // this.bigLoading = false;
        });
    },
    // 数量
    getProductList(gameId, currency, pay_mode) {
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      // this.emptyProductSelectInfo();
      // 根据gameid查询接口4 商品信息，gameid依赖区服接口，需要用户先选择 大区服/小区服，确定gameid
      this.$apis.paygame
        .getProductList(this.distribution_region, gameId, currency, pay_mode)
        .then(({ data }) => {
          this.$toast.clear();
          if (data.code == 0 && data.data && data.data.length) {
            this.productList = data.data;
          } else {
            this.productList = [];
          }
        });
    },
    // 获取支付方式
    async getChannelList(currency) {
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      const res = await this.$apis.paygame.getChannelList(
        this.distribution_region,
        this.dataForm.game_id,
        currency
      );
      if (res.data.code == 0 && res.data.data.length) {
        this.payChannel = res.data.data;
        // 获取商品列表
      } else if (res.data.code == 2000) {
        this.$router.push({ path: "/pay_h5/pg_record" });
      }
      this.$toast.clear();
    },
    // 获取支持的币种列表
    getCurrencyList() {
      this.$apis.paygame
        .getCurrencyList(
          this.distribution_region,
          this.serverRoleList[0].game_id
        )
        .then(({ data }) => {
          if (data.code === 0 && data.data && data.data.length) {
            this.currencyList = data.data;

            // 币种赋初始值
            // this.params.currency = this.currencyList[0].currency;
            // 支付方式
            // this.getChannelList();
          } else {
            this.currencyList = [];
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.setoutpay {
  width: 100%;
  height: auto;
  margin-top: 0.48rem;
  border-top: 1px solid white;
  &-content {
    width: 95%;
    height: auto;
    margin: auto;
    display: flex;
    margin-top: 0.4rem;
    position: relative;
    .tox {
      position: absolute;
      right: 0;
      top: 0;
      width: 0.55rem;
      height: 0.55rem;
      display: flex;
      > img {
        width: 0.55rem;
        height: 0.55rem;
        border-radius: 0.05rem;
        object-fit: cover;
      }
    }
    &-left {
      width: auto;
      height: auto;
      ul {
        display: flex;
        flex-flow: column;
        .head {
          width: auto;
          height: 0.12rem;
          font-size: 0.11rem;
          font-weight: 400;
          color: #bdbdbd;
          &:nth-of-type(1) {
            margin-bottom: 0.25rem;
            margin-top: 0.07rem;
          }
        }
        .inpuname {
          width: auto;
          height: 0.37rem;
          margin-top: 0.35rem;
          font-size: 0.11rem;
          line-height: 0.37rem;
          font-weight: 400;
          color: #bdbdbd;
        }
      }
    }
    &-right {
      width: auto;
      height: auto;
      flex: 1;
      ul {
        position: relative;
        display: flex;
        flex-flow: column;
        align-items: flex-end;
        .heads {
          width: 95%;
          height: 0.12rem;
          font-size: 0.11rem;
          font-weight: 400;
          color: #444444;

          &:nth-of-type(1) {
            margin-bottom: 0.25rem;
            margin-top: 0.07rem;
          }
        }
        .inpunames {
          width: 95%;
          height: auto;
          min-height: 0.37rem;
          margin-top: 0.35rem;
          &.pay {
            display: flex;
            align-items: center;
            span {
              &:nth-of-type(1) {
                font-size: 0.15rem;
                font-weight: 800;
                color: #54c5f8;
              }
              &:nth-of-type(2) {
                margin-left: 0.07rem;
                font-size: 0.11rem;
                font-weight: 400;
                color: #bdbdbd;
              }
            }
          }
          &.codes {
            .yanzm {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 1.12rem;
              height: 0.3rem;
              margin-right: 0.05rem;
              background: rgba(240, 155, 212, 0);
              border: 1px solid #cccccc;
              border-radius: 0.14rem;
              display: flex;
              justify-content: center;
              align-items: center;
              box-sizing: border-box;
              background: white;
            }
          }
        }
      }
    }
  }
  &-btn {
    width: 1.82rem;
    height: 0.35rem;
    margin: auto;
    margin-top: 0.4rem;
    background: #54c5f8;
    border-radius: 0.17rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 0.12rem;
      font-weight: 400;
      color: #ffffff;
    }
  }
  &-state {
    width: 100%;
    height: auto;
    margin-top: 0.2rem;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.18rem;
      height: 0.17rem;
    }
    span {
      margin-left: 0.1rem;
      font-size: 0.09rem;
      font-weight: 400;
      color: #444444;
       a {
        color: #50bbe5;
      }
    }
  }
}
</style>
